import type { WorkPreparationState } from '../api';
import { Utils } from '../utilities/Utils';

export type WorkPreparationSnapshotInput = {
  [K in keyof WorkPreparationState]?: unknown;
};

export const buildWorkPreparationSnapshot = (
  input: WorkPreparationSnapshotInput,
  overrides?: Partial<WorkPreparationState>,
): WorkPreparationState => ({
  tableOfContentData: input.tableOfContentData ?? undefined,
  rescueplanData: input.rescueplanData ?? undefined,
  riskAssesmentContainerData: input.riskAssesmentContainerData ?? undefined,
  factsAboutScaffoldingData: input.factsAboutScaffoldingData ?? undefined,
  selfControlContainerData: input.selfControlContainerData ?? undefined,
  planForConductData: input.planForConductData ?? undefined,
  monteringsanalysData: input.monteringsanalysData ?? undefined,
  factsAboutWeatherProtectionData: input.factsAboutWeatherProtectionData ?? undefined,
  selfControlWeatherProtectionData: input.selfControlWeatherProtectionData ?? undefined,
  preWorkControlData: input.preWorkControlData ?? undefined,
  projectNumber: input.projectNumber ?? undefined,
  customer: input.customer ?? undefined,
  sharePointFolderId: input.sharePointFolderId ?? undefined,
  isWeatherProtectionProject: input.isWeatherProtectionProject ?? undefined,
  ...overrides,
} as WorkPreparationState);

export const applyWorkPrepDateFallbacks = (workprep: WorkPreparationState): WorkPreparationState => {
  const workPreparationCopy = JSON.parse(JSON.stringify(workprep)) as WorkPreparationState;

  if (workPreparationCopy.factsAboutScaffoldingData && !Utils.isDateInitialized(workPreparationCopy.factsAboutScaffoldingData.scaffoldingSubmittedOnDate)) {
    workPreparationCopy.factsAboutScaffoldingData.scaffoldingSubmittedOnDate = 'Se QR kod';
  }
  if (workPreparationCopy.factsAboutWeatherProtectionData && !Utils.isDateInitialized(workPreparationCopy.factsAboutWeatherProtectionData.scaffoldingSubmittedOnDate)) {
    workPreparationCopy.factsAboutWeatherProtectionData.scaffoldingSubmittedOnDate = 'Se QR kod';
  }
  return workPreparationCopy;
};
